import { EReputationMatchResult } from "src/core/types/entity";

type SourcesSectionProps = {
  selectedMatch: EReputationMatchResult;
};

export const SourcesSection = ({ selectedMatch }: SourcesSectionProps) => {
  if (!selectedMatch?.detail?.sources?.length) {
    return null;
  }

  return (
    <div className="flex flex-col mt-6 mx-10">
      <ul className="list-disc list-inside font-light space-y-1">
        {selectedMatch?.detail?.sources?.map((source, idx) => {
          const isUrl = source.startsWith("http://") || source.startsWith("https://");

          return (
            <li key={`source-${idx}-${source}`} className="overflow-hidden text-ellipsis">
              {isUrl ? (
                <a
                  href={source}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-foreground underline inline-block max-w-[90%] truncate"
                  title={source}
                >
                  {source}
                </a>
              ) : (
                <span>{source}</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
